import { NavLink } from "react-router-dom";
import { User, Wrench, ShieldCheck } from "lucide-react";
import { cx } from "./kit";

const links = [
  { to: "/customer", label: "Customer", icon: User, testid: "role-toggle-customer" },
  { to: "/crew", label: "Crew", icon: Wrench, testid: "role-toggle-crew" },
  { to: "/admin", label: "Admin", icon: ShieldCheck, testid: "role-toggle-admin" },
];

export default function RoleSwitcher() {
  return (
    <div className="no-print fixed bottom-0 inset-x-0 z-50 flex justify-center pb-3 px-3 pointer-events-none">
      <div className="pointer-events-auto flex gap-1 bg-[#12193a]/95 backdrop-blur-xl border border-cyan-500/25 rounded-2xl p-1.5 shadow-2xl w-full max-w-md">
        {links.map(({ to, label, icon: Icon, testid }) => (
          <NavLink key={to} to={to} data-testid={testid}
            className={({ isActive }) => cx(
              "flex-1 flex flex-col items-center gap-0.5 py-2 rounded-xl text-xs font-bold transition-all",
              isActive ? "bg-cyan-500 text-slate-950 shadow-[0_0_15px_rgba(0,210,254,0.4)]" : "text-slate-400 hover:text-cyan-300"
            )}>
            <Icon size={18} strokeWidth={2.4} />
            {label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
